import React, {useState} from 'react';
import classes from './Material.module.css';
import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import KeyboardDoubleArrowDownRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowDownRounded';
import KeyboardDoubleArrowUpRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowUpRounded';

const material = {

    basic: [
        {name: '인화성가스', nameline:'', amount: 5000, line: '(저장: 200,000)'},
        {name: '인화성액체', nameline:'', amount: 5000, line: '(저장: 200,000)'},
        {name: '메틸이소시아네이트', nameline:'', amount: 150, line: ''},
        {name: '포스겐', nameline:'', amount: 750, line: ''},
        {name: '아크릴로니트릴', nameline:'', amount: 20000, line: ''},
        {name: '암모니아', nameline:'', amount: 20000, line: ''},
        {name: '염소', nameline:'', amount: 20000, line: ''},
        {name: '이산화황', nameline:'', amount: 250000, line: ''},
        {name: '삼산화황', nameline:'', amount: 75000, line: ''},
        {name: '이황화탄소', nameline:'', amount: 5000, line: ''},
        {name: '시안화수소', nameline:'', amount: 1000, line: ''},
        {name: '불화수소(무수불산)', nameline:'', amount: 1000, line: ''},
        {name: '염화수소(무수염산)', nameline:'', amount: 20000, line: ''},
        {name: '황화수소', nameline:'', amount: 1000, line: ''},
        {name: '질산암모늄', nameline:'', amount: 500000, line: ''},
        {name: '니트로글리세린', nameline:'', amount: 10000, line: ''},
        {name: '트리니트로톨루엔', nameline:'', amount: 50000, line: ''},
        {name: '수소', nameline:'', amount: 50000, line: ''},
        {name: '산화에틸렌', nameline:'', amount: 10000, line: ''},
        {name: '포스핀', nameline:'', amount: 50, line: ''},
        {name: '실란', nameline:'', amount: 50, line: ''},
    ],
    
    extend: [
        {name: '질산', nameline:'(중량94.5%이상)', amount: 250, line: ''},
        {name: '발연황산', nameline:'(삼산화황중량 65%이상 80% 미만)', amount: 500000, line: ''},
        {name: '과산화수소', nameline:'(중량 52%이상)', amount: 3500, line: ''},
        {name: '톨루엔디이소시아네이트', nameline:'', amount: 100000, line: ''},
        {name: '클로로술폰산', nameline:'', amount: 500000, line: ''},
        {name: '브롬화수소', nameline:'', amount: 2500, line: ''},
        {name: '삼영화인', nameline:'', amount: 750000, line: ''},
        {name: '염화벤질', nameline:'', amount: 750000, line: ''},
        {name: '이산화염소', nameline:'', amount: 500, line: ''},
        {name: '염화티오닐', nameline:'', amount: 150, line: ''},
        {name: '브롬', nameline:'', amount: 100000, line: ''},
        {name: '일산화질소', nameline:'', amount: 1000, line: ''},
        {name: '붕소트리염화물', nameline:'', amount: 1500, line: ''},
        {name: '메틸에틸케톤과산화물', nameline:'', amount: 2500, line: ''},
        {name: '삼불화붕소', nameline:'', amount: 150, line: ''},
        {name: '니트로아닐린', nameline:'', amount: 2500, line: ''},
        {name: '염소트리플루오르화', nameline:'', amount: 500, line: ''},
        {name: '불소', nameline:'', amount: 20000, line: ''},
        {name: '시아누르플루오르화물', nameline:'', amount: 50, line: ''},
        {name: '질소트리플루오르화물', nameline:'', amount: 2500, line: ''},
        {name: '니트로셀롤로오스', nameline:'(질소함유량 126%이상)', amount: 100000, line: ''},
        {name: '과산화벤조일', nameline:'', amount: 100000, line: ''},
        {name: '과염소산암모늄', nameline:'', amount: 3500, line: ''},
        {name: '디클로로실란', nameline:'', amount: 1500, line: ''},
        {name: '디에틸알루미늄염화물', nameline:'', amount: 2500, line: ''},
        {name: '다이소프로필퍼옥시디카보네이트', nameline:'', amount: 3500, line: ''},
        {name: '불산', nameline:'(중량 1%이상)', amount: 1000, line: ''},
        {name: '염산', nameline:'(중량 1%이상)', amount: 20000, line: ''},
        {name: '황산', nameline:'(중량 10%이상)', amount: 20000, line: ''},
        {name: '암모니아수', nameline:'(중량 10%이상)', amount: 20000, line: ''},
        
    ]

}


const Material = props => {
    const [expandList, setExpandList] = useState(false);

    return (
        <Box className={classes['material-wrapper']}>

            <Box className={expandList ? `${classes['material-area']} ${classes.expanded}` : classes['material-area']}>
                <table className={classes.table}>
                    <caption>
                        {props.caption}
                    </caption>
                    <thead>
                        <tr>
                            <th>유해·위험물질명</th>
                            <th>규정수량(kg)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {material[props.division].map((item,index) => (
                            <tr key={index}>
                                <td>
                                    {item.name}
                                    {item.nameline && <p>{item.nameline}</p>}
                                </td>
                                <td>
                                    {item.amount.toLocaleString()}
                                    {item.line && <p>{item.line}</p>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Box>

            <Box className={ expandList ? `${classes.more} ${classes['more-expanded']}` : classes.more }>
                <IconButton color="primary" size="small" onClick={() => setExpandList(!expandList)}>
                    <span style={{display: 'flex', alignItems: 'center'}}>{expandList ? <KeyboardDoubleArrowUpRoundedIcon/> : <KeyboardDoubleArrowDownRoundedIcon/>}
                    {expandList ? '접기': '펼치기'}
                    </span>
                </IconButton>
            </Box>
        </Box>
    )
}

export default Material;